export enum BuilderDeveloperType {
    Builder = 3,
    Developer = 4
}
export enum PopupType {
    Add = 1,
    Edit = 2
}
export enum PlateformId {
    MobileApp = 1,
    WebApp = 2
}
export enum PopBreakpoints {
    Small = 'modal-sm',
    Large = 'modal-lg',
    ExtraLarge = 'modal-xlg',
    FullWidth = 'fullWidth'
}
export enum PostNewLaunchImageControl {
    UPLOAD_PROJECT_BANNER = 1,
    UPLOAD_PROJECT_LOGO = 2,
    // UPLOAD_BRIEF_OFFER_DETAILS = 3,
    UPLOAD_E_BROCHURE = 4,
    UPLOAD_DETAILED_BROKER_OFFER = 5,
    FLOOR_PLAN = 6,
    UPLOAD_PROJECT_PICS_GALLERY = 7,
    UPLOAD_VIDEO = 8
}
export enum FOSType {
    Call = 1,
    Visit = 2,
    Database = 3
}
export enum PostProperyRRStepper {
    Back = 0,
    BasicDetails = 1,
    AdditionalDetails = 2,
    Amenities = 3,
}
export enum UserRoleName {
    Admin = "Admin",
    Broker = "Broker",
    Builder = "Builder",
    Developer = "Developer",
    Empty = "",
} 
export interface UsersAll {
    userId:   number;
    userName: string;
    roleId:   number | null;
    roleName: UserRoleName;
}
export enum PropertyDetailsTab {
    BasicDetails = 1,
    AdditionalDetails = 2,
    Amenities = 3,
}